import type { SVGProps } from 'react';

const Shield = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.26835 1.60871C1.51425 1.84196 1 2.53955 1 3.32927V7.53237C1 10.3124 2.44183 12.8934 4.8086 14.3499L7.06266 15.7371C7.6415 16.0933 8.37153 16.093 8.95008 15.7363L11.1971 14.3508C13.5606 12.8935 15 10.3145 15 7.5368V3.32927C15 2.53955 14.4858 1.84196 13.7316 1.60871L9.06329 0.164749C8.3706 -0.0495048 7.62939 -0.0495045 6.93671 0.164749L2.26835 1.60871ZM11.8864 6.03527C12.2378 5.6838 12.2378 5.11395 11.8864 4.76248C11.5349 4.41101 10.9651 4.41101 10.6136 4.76248L6.74998 8.62608L5.38637 7.26248C5.0349 6.91101 4.46505 6.91101 4.11358 7.26248C3.76211 7.61395 3.76211 8.1838 4.11358 8.53527L6.11358 10.5353C6.28236 10.7041 6.51128 10.7989 6.74998 10.7989C6.98867 10.7989 7.21759 10.7041 7.38637 10.5353L11.8864 6.03527Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { Shield };
